export function isLocalUrl(value) {
  try {
    return ['127.0.0.1', 'localhost'].includes(new URL(value).hostname)
  } catch {
    return false
  }
}

export function assertLocalDatabaseTarget({ enabled, url }) {
  if (!enabled) return
  if (!isLocalUrl(url)) {
    throw new Error('Local test mode refused a non-local Supabase target.')
  }
}

export function assertLocalFrontendIsolation({ enabled, supabaseUrl, siteUrl, stripePublishableKey }) {
  if (!enabled) return

  assertLocalDatabaseTarget({ enabled, url: supabaseUrl })
  if (!isLocalUrl(siteUrl)) {
    throw new Error('Local test mode refused a non-local site URL.')
  }
  if (stripePublishableKey) {
    throw new Error('Local test mode requires Stripe.js to be disabled.')
  }
}
